// Note on using window.functionName: Webpack encapsulates bare 'functions' in a wrapper of some sort,
// so the function declaration happens within that scope, not the global scope.
// Assigning the function to a property on the `window` object resolves that.
// @link https://stackoverflow.com/questions/38975776/webpack-function-is-not-defined

/*!
 * Convert a string to title case
 * @link: https://gist.github.com/SonyaMoisset/aa79f51d78b39639430661c03d9b1058#file-title-case-a-sentence-for-loop-wc-js
 * @link: https://vanillajstoolkit.com/helpers/totitlecase/
 * @param  {String} str The string to convert to title case
 * @return {String}     The converted string
 */
window.toTitleCase = function (str) {
	str = str.toLowerCase().split(' ');
	for (var i = 0; i < str.length; i++) {
		str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
	}
	return str.join(' ');
};


// @link https://stackoverflow.com/a/28953167
window.isEmpty = function ( val ) {
    if (val === undefined)
    	return true;
    if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
        return false;
    if (val == null || val.length === 0)// null or 0 length array
        return true;
    if (typeof (val) == "object") {
        var r = true;
        for (var f in val)
            r = false;
        return r;
    }
    return false;
};